<template>
  <v-alert
    v-show="updateAlert"
    dismissible
    dark
    color="primary"
    style="position: absolute; bottom: 5px; right: 15px; z-index: 7"
  >
    <v-row no-gutters align="center">
      <v-col class="grow">
        New Update Available!
      </v-col>
      <v-col class="shrink">
        <v-btn outlined small class="ml-3" @click="updateServiceWorker">Refresh</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { messageSW } from "workbox-window";

export default {
  data: () => ({
    updateAlert: false,
    registration: null
  }),
  mounted: function() {
    document.addEventListener("swUpdated", this.showUpdateAlert);
  },
  methods: {
    showUpdateAlert: function(event) {
      this.registration = event.detail;
      this.updateAlert = true;
    },
    updateServiceWorker: function() {
      if (this.registration && this.registration.waiting) {
        messageSW(this.registration.waiting, { type: "SKIP_WAITING" });
        this.updateAlert = false;
      }
    }
  }
};
</script>

<style></style>
